var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_vm._v(_vm._s(_vm.pageTitle)+" "),(_vm.taskCount)?_c('span',[_vm._v("("+_vm._s(_vm.taskCount)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }